<template>
  <split-pane :defaultPercent="20">
    <div class="mw-split-left" slot="paneL">
      <div class="mw-panel-y mw-panel__tree">
        <div class="mw-toolbar__body mw-app__edit" ref="treeContainer">
          <mw-tree  :url="treeUrl"
              :async="true" :multiple="false" :selectFirst="true"
                  :expandedFirst="true" :autoLoad="true"
                  :dragEnable="false"
                  @changed="treeClick" ref="mwTree" ></mw-tree>
        </div>
      </div>
    </div>
    <div class="flow-config-dialog mw-split-right" slot="paneR">
      <toolbar-table :layout="layout" :autoLoad="false" ref="dataTable" :defaultParams="defaultParams">
          <span slot="more">
              <el-dropdown trigger="hover" @command="handleCommand">
                <el-button class="el-dropdown-link">
                  更多 <i class="fa fa-angle-double-right"></i>
                </el-button>
                <el-dropdown-menu class="mw-toolbar-dropdown" slot="dropdown">
                  <el-dropdown-item command="export">导出</el-dropdown-item>
                  <el-dropdown-item divided command="">
                    <el-upload
                      style="margin: 0 -20px;"
                      v-bind="importProps"
                    >
                      <div style="padding:0px 50px 0 20px;text-align:left;">导入</div>
                    </el-upload>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </span>
      </toolbar-table>
    </div>
  </split-pane>

</template>
<script>
export default {
    data() {
      let me = this;
      return {
        treeUrl:PF.getApplicationPath()+"/api/maintain/listTableCategory",
        defaultParams:{},
        layout:[],
        importProps: {
          action: '/api/maintain/importSqlTableData',
          autoUpload: true,
          showFileList: false,
          onSuccess: async (response) => {
            if (response && response.success) {
              this.mwMsg('导入成功');
            } else {
              this.mwMsg('waring', response && response.msg || '导入失败');
            }
          },
          onError: (err, file, fileList) => {
            this.mwMsg('waring', '导入失败');
          }
        }
      };
    },
    created() {
      let me = this;
      me.layout = [
          [{
                  span: 0,
                  type: 'menu',
                  label: '数据清理及导出',
                  api: '/#api/maintain/listTableData',
                  defaultParams: {limit: 250 },
                  defaultSort: [{ sort: 'sn', dir: 'desc' }],
                  nowrap: false,
                  columns: [
                      { type: 'selection', reserve: true },
                      { prop: 'cname', label: '表中文名称', tooltip: true, width: '250' },
                      { prop: 'name', label: '表名', tooltip: true },
                      { prop: 'count', label: '数据量', width: '150', tooltip: true }
                  ]
              },{
                span: 8,
                type: 'button',
                items: [{
                  label: '数据删除',
                  icon: 'fa fa-trash-o fa-fw',
                  func: me.clearDatas
                }], suffixSlot: "more"
              }
          ]
      ];
    },
    methods: {
        handleCommand(command) {
          if (command === 'export') {
            let data = this.mwRef('dataTable').getMultipleSelection();
            this.mwApi.maintain.exportSqlTableData(data);
          }
        },
        treeClick:function(data){
          let params = this.mwRef('dataTable').defaultParams;
          this.mwRef('dataTable').clearSelection();
          params.pid = data.id;
          params.dataType = data.dataType || "";
           this.mwRef('dataTable').refreshTable();
        },

        clearDatas:function(data){
          let me = this;
          if (data.length == 0) {
              this.mwMsg('info', '请选择');
              return;
          }
          this.$confirm('确定要删除数据?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
              let ids = [];
              $.each(data,function(i,d){
                ids.push(d.id);
              })
              PF.invoke("#api/maintain/clearTableData",ids).then(function(r){
                me.mwRef('dataTable').refreshTable();
              });
          });
        }
    }
};
</script>
<style >
.server-log pre {
    background: #555;
    color: white;
    border: none;
    word-break: normal;
    white-space: pre-wrap;
}
</style>



// WEBPACK FOOTER //
// src/modules/index/views/maintain/clearDataOrExpImpl.vue